import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-707616e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ml-12" }

import { withDefaults, getCurrentInstance } from 'vue'
import translate from '@/api/translate';

interface main {
	text?: string,
	loading?: boolean,
}
export default /*#__PURE__*/_defineComponent({
  __name: 'LoadingBtn',
  props: {
    text: { default: "保存" },
    loading: { type: Boolean, default: false }
  },
  emits: ["change"],
  setup(__props: any, { emit: __emit }) {

;



const { proxy } = getCurrentInstance() as any;
const emits = __emit;

const Submit = () => {
	emits("change");
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      class: "save-btn",
      disabled: _ctx.loading,
      loading: _ctx.loading,
      type: "primary",
      onClick: Submit
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.loading ?
			_unref(translate).ShowText('保存中') : _unref(translate).ShowText('保存')), 1)
      ]),
      _: 1
    }, 8, ["disabled", "loading"])
  ]))
}
}

})